import BaseController from "./BaseController";
import { TaskNavigationInfo } from "../model/ts/types/TaskNavigationInfo";
import VBox from "sap/m/VBox";
import View from "sap/ui/core/mvc/View";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import DialogUtils from "../model/ts/subtasks/utils/DialogUtils";
import LogHandler from "../model/ts/handlers/LogHandler";
import ElementRegistry from "sap/ui/core/ElementRegistry";

/**
 * @namespace sap.mcsuite.controller
 */
export default class ModuleController extends BaseController {
    onInit(): void {
    
        const currentRoute = this.getCurrentRoute();
        if (currentRoute) {
            currentRoute.attachPatternMatched(this.loadTask.bind(this));
        }
    }

    private loadTask(event: Route$PatternMatchedEvent): void {
        const params = event.getParameters().arguments as TaskNavigationInfo;
        const taskContainer = this.getView().byId("taskContainer") as VBox;
        if (!taskContainer) {
            console.error("Task container not found in the view.");
            return;
        }
        setTimeout(() => {    
            taskContainer.setBusy(true);
            taskContainer.destroyItems();
            this.getOwnerComponent().runAsOwner(this.getCreateTaskFunction(params, taskContainer));
        }, 0);
    }

    private getCreateTaskFunction(params: TaskNavigationInfo, taskContainer: VBox): () => Promise<void> {
        return () => {
            return View.create({
                viewName: `sap.mcsuite.modules.${params.module}.tasks.${params.task}.view.Task`,
                type: "XML",
                viewData: { queryParameters: params["?query"] },
            }).then((view) => {
                LogHandler.display("Task view created successfully.");
                const controller = view.getController() as BaseController & { SCOPES: string[] };
                const scopes = controller.SCOPES;
                const user = this.getOwnerComponent().getUser();
                if (user.isAuthenticated() === false) {
                    // await authentication
                    user.attachAuthenticated(() => {
                        if (!this.checkUserScopes(user, scopes)) {
                            LogHandler.display("User is not authenticated. Awaiting authentication...");
                            this.showUnauthorizedAccessDialog();
                        }
                        else {
                            taskContainer.destroyItems();
                            taskContainer.addItem(view);
                            taskContainer.setBusy(false);
                        }
                    });
                }
                else if (user.hasScopeRegex("admin") || scopes.some(scope => user.hasScopePart(scope))) {
                        taskContainer.destroyItems();
                        taskContainer.addItem(view);
                        taskContainer.setBusy(false);
                }
                else {
                    console.error("User does not have the required scopes to access this task.");
                    this.showUnauthorizedAccessDialog();
                }
            }).catch((error) => {
                console.error("Error creating task view:", error);
                taskContainer.destroyItems();
                taskContainer.setBusy(false);
            });
        }
    }

    private checkUserScopes(user: any, scopes: string[]): boolean {
        if (!user.isAuthenticated()) {
            return false;
        }
        return scopes.some(scope => user.hasScopePart(scope));
    }

    private showUnauthorizedAccessDialog(): void {
        DialogUtils.openDialog(
                        this,
                        "sap.mcsuite.view.fragments.dialogs.UnauthorizedAccess",
                    );
    }
        
}